import Settings from '../olr-common/Settings';

export default function TodoListService($http) {
  let url = Settings.backendEnv + "/api/v1/todo";

  this.saveTodo = function(todoObj) {
    var req = {
      method:  "POST",
      url:    url,
      data:   todoObj
    };

    return $http(req);
  };

  this.getAllTodo = function(){
    return $http({method: 'GET',url: url});
  };

  this.deleteTodo = function(todoObj) {
    var req = {
      method: "DELETE",
      url:    url + "/" + todoObj.todoId
    };

    return $http(req);
  };
}

export function TodoListServiceStub($httpBackend) {
  $httpBackend
    .whenPOST('/mainv1/api/todo')
    .respond(function(method, url, data) {
      let timestamp = new Date().getUTCMilliseconds();
      return [200, {todoId: timestamp}, {/* response header */}];
    });

  $httpBackend
    .whenGET('/mainv1/api/todo')
    .respond(function(method, url, data) {
      var allTodos = localStorageService.get('allTodo');
      return [200, allTodos, {/* response header */}];
    });

  // $httpBackend
  //   .whenPUT(/.*?mainv1\/api\/todo?.*/g)
  //   .respond(function(method, url, data) {
  //     return [200, {todo: 'updated'}, {/* response header */}];
  //   });

  // $httpBackend
  //   .whenDELETE(/.*?mainv1\/api\/todo?.*/g)
  //   .respond(function(method, url, data) {
  //     return [200, {}, {/* response header */}];
  //   });
}




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/TodoListService.js
 **/